<div class="prel container">
    <div class="row">
        <div class="c12">
            <div class="card mt-2">
                <div class="d-flex align-items-center gap-2 w-100">
                    <div class="d-flex align-items-center gap-2 flex-grow-1">
                        <div class="card-header d-flex justify-content-between flex-shrink-0" translate>
                            lblSyncFailAppointment
                        </div>
                        <div class="input-group" style="max-width: 320px; width: 100%;">
                            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblQuicksearch' | translate }}"
                                [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onEnterPress()" />
                            <div class="input-group-append">
                            <button type="button" class="btn btn-primary" (click)="onEnterPress()" aria-label="Center Align">
                                <em class="fa fa-search" aria-hidden="true"></em>
                            </button>
                            </div>
                        </div>
                    </div>
                    <div class="font16 fontbold text-end flex-shrink-0 ms-auto mr-4">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        totalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <div class="table-responsive afx-table-sticky max-h150">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th scope="col" translate>lblType</th>
                                <th scope="col" translate (sort)="onSort($event)" sortable="workOrderNo">lblWoNo</th>
                                <th scope="col" translate>lblWoStatus</th>
                                <th scope="col" translate (sort)="onSort($event)" sortable="licensePlate">lblRegNumber</th>
                                <th scope="col" translate (sort)="onSort($event)" sortable="sourceCreation">lblSource</th>
                                <th scope="col" translate>lblCustomer</th>
                                <th scope="col" translate>lblDealersName</th>
                                <th scope="col" translate (sort)="onSort($event)" sortable="bookedDateTime">lblBookedDate</th>
                                <th scope="col" translate (sort)="onSort($event)" sortable="createdDateTime">lblCreatedDate</th>
                                <th scope="col" translate>lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="appointmentList?.length>0; else load_else">
                                <tr *ngFor="let appointment of appointmentList; let i=index">
                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight [result]="appointment.appointmentType">
                                        </ngb-highlight>
                                    </td>
                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <div class="app-wo-customerwaiting">
                                            <div>
                                                <div *ngIf="appointment.isCustomerWaiting === true" class="d-flex align-items-center">
                                                    <em class="fas fa-clock mr-2"></em> {{appointment.workOrderNo}}
                                                </div>
                                                <div *ngIf="appointment.isCustomerWaiting === false">
                                                    {{appointment.workOrderNo}}
                                                </div>
                                            </div>
                                            <div class="widget-appointment-no" *ngIf="appointment.widgetAppointmentNo">
                                                #{{ appointment.widgetAppointmentNo }}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="position-relative click" (click)="OpenEditView(appointment)">
                                        <div class="mx-auto text-center">
                                            <div class="color-box" [ngbTooltip]="appointment.workOrderStatus"
                                                tooltipClass="tooltip-inner-width"
                                                [style.background-color]="appointment.workOrderStatusColor">
                                            </div>
                                        </div>
                                    </td>
                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <div class="flmid">
                                            <div class="licplate LPNo d-flex">
                                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                {{appointment.licensePlate}}
                                            </div>
                                            <div class="imgWid">
                                                <img af-brand-logo [data-code]="appointment.brandCode" data-type="BRAND"
                                                    class="{{appointment.brandCode}}-icon common"
                                                    [title]="appointment.brandCode" class="brandicon" alt="img" />
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <ngb-highlight class="flmid semibold fs-12px lh-16px"
                                                [result]="appointment.modelName">
                                            </ngb-highlight>
                                        </div>
                                    </td>

                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight class="flmid sourceBox rounded-0 justify-content-center"
                                            [result]="appointment.sourceCreation">
                                        </ngb-highlight>
                                    </td>

                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight class="fs-14px semibold lh-18px d-block"
                                            [result]="appointment.customerName">
                                        </ngb-highlight>
                                        <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                                            <em _ngcontent-xdg-c220=""
                                                class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                            <span class="fs-12px"
                                                *ngIf="appointment && appointment.mobileCode">+{{appointment.mobileCode}}-</span>
                                            <ngb-highlight class="fs-12px" [result]="appointment.mobileNo"
                                               >
                                            </ngb-highlight>
                                        </div>

                                    </td>

                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight [result]="appointment.dealerName">
                                        </ngb-highlight>
                                    </td>

                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight [result]="appointment.bookedDate">
                                        </ngb-highlight>
                                    </td>

                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <div class="">
                                            <div class="">
                                                {{ appointment.createdDateTime | date:'short'}}
                                            </div>
                                            <ngb-highlight class="fs-12px lh-18px d-block"
                                                [result]="appointment.userName">
                                            </ngb-highlight>
                                        </div>
                                    </td>

                                    <td class="nowrap text-center">
                                        <ng-container>
                                            <a class="btn btn-ico"
                                                (click)="OpenEditView(appointment)"
                                                ngbTooltip="{{'lblView' | translate}}">
                                                <em class="far fa-eye fa-lg"></em>
                                            </a>
                                            <a class="btn btn-ico"
                                                (click)="CreateAppointment(appointment,mymodal)"
                                                ngbTooltip="{{'lblRestoreAppointment' | translate}}">
                                                <em class="fas fa-clipboard-check fa-lg"></em>
                                            </a>
                                        </ng-container>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="12" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblRestoreAppointment</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
       <span translate>lblAreYouSureWantToRestoreAppointment</span>
    </div>
    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate aria-label="Center Align" (click)="modal.dismiss(true)">lblRestore</button>
            <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>